import React, { Component } from 'react';
import { apiGetP } from '../../GanjiTools';
import { Accordion, ContextMenu, List, Menu } from 'devextreme-react';
import MasterLayout from './MasterLayout';
import './MasterLayout.css';
import CommandManager from '../CommandManager';
import Badge from '../utils/Badge';
import Globals from '../Globals';
import { isMobile } from 'react-device-detect';
import FontAwesomeIcon from '../utils/FontAwesomeIcon';
import { style } from 'typestyle';
import Theme from '../theme/Theme';

//import '../../../src/additional.css';

class SideMenu extends Component {

    accoSubItemStyle = {
        padding: '0 5px', overflow: 'hidden', fontSize: this.props.smallTexts ? '0.8rem' : '1rem',
        //color: Theme.col0(), backgroundColor:Theme.col1('steelblue'),
    };

    //static collapsed = false;

    accoTitleStyle = selected => selected ?
        ({
            fontWeight: '1000', marginRight: '10px', fontSize: this.props.smallTexts ? '1rem' : '1.2rem',
            color: Theme.col2('lightyellow'),
            backgroundColor: Theme.col1('steelblue'),
        }) :
        ({
            fontWeight: '700', marginRight: '10px', fontSize: this.props.smallTexts ? '1rem' : '1.2rem',
            color: Theme.col2('lightblue'),
            backgroundColor: Theme.col1('steelblue'),
        });

    //static accoSelectedIndex = 0;
    state = {
        collapsed: this.props.collapsed, // SideMenu.collapsed, // 
        selectedIndex: window.accoSelectedIndex ?? 0,
        selectedSubIndex: window.accoSelectedSubIndex ?? 0,
    };

    assignCommand = menuItem => {
        menuItem.url = menuItem.cmd ?? menuItem.path ?? menuItem.component ?? menuItem.url;

        if (menuItem.items?.length > 0)
            for (let sub of menuItem.items)
                this.assignCommand(sub);
        else
            menuItem.onClick = () => {
                //console.log('menu item clicked ', menuItem, e);
                this.props.onItemClick?.(menuItem);
            }
    }

    setItems = (items, targetsList, whenDone) => {
        if (items?.length > 0)
            items.forEach(mi => this.assignCommand(mi));

        SideMenu.targetsList = targetsList;
        this.setState({ items, loading: false }, whenDone);
    }

    componentDidMount() {
        let { items, targetsList } = this.props;

        if (items?.length > 0) {
            this.setItems(items, targetsList);
            return;
        }

        apiGetP(this.props.url ?? `/api/parssaman/sideMenu/${window.user?.id ?? 0}`) //'/api/menu/items', /*@@*/
            .then(res => {
                let { error, list, targetsList } = res ?? { error: 'No response.' };

                if (error?.length > 0) {
                    console.log('error loading top menu items:', res.error);
                    return;
                }
                console.log('side menu items: ', list);
                this.setItems(list, targetsList);
            })
            .catch(console.log);
    }

    onClickSubMenu = (menuItem, ix) => {
        window.selectedSubIndex = ix;
        this.props.onCommandExecuting?.(menuItem, ix);
        // if (this.props.mobileAutoHideSideMenu)
        //     this.setCollapsed(true);

        if (this.props.onClickSubMenu)
            this.props.onClickSubMenu(menuItem);
        else if (Globals.onClickSideSubMenu)
            Globals.onClickSideSubMenu(menuItem);
        else {
            menuItem.url = menuItem.cmd ?? menuItem.path ?? menuItem.component ?? menuItem.url;
            console.log('>> menu item clicked ', menuItem?.itemData);
            CommandManager.processP(menuItem) //.url, menuItem.itemData ?? menuItem, { rows: SideMenu.targetsList })
                .then(component => {
                    if (component)
                        window.setInnerBody(component, () => this.props.onCommandExecuted?.(menuItem, ix));
                    else
                        this.props.onCommandExecuted?.(menuItem, ix)
                })
                .catch(window.notif);
        }
        //this.props.onItemClick?.(menuItem);
    }

    renderAccoSubItem = (item, ix, extraStyles) => {
        return (
            <div
                style={{
                    display: 'inline-flex', overflow: 'hidden', paddingRight: '15px', width: '100%',
                    fontSize: this.accoSubItemStyle.fontSize, alignItems: 'center', height: '42px', //! 60px is only for rahkala!!!!! default:42px
                    position: 'relative',
                    ...extraStyles
                }}
                className={'mdh_acco_subitem ' + style({
                    color: ix === window.selectedSubIndex ? Theme.col2('black') : Theme.col3('dimgray'),
                    backgroundColor: Theme.col1('white'),
                    '&:hover': {
                        color: Theme.col2('blue'),
                        backgroundColor: Theme.col4('white'),
                    }
                })}
                onClick={() => this.onClickSubMenu(item, ix)}
            >
                {//this.props.collapsed !== false &&
                    !(item.icon?.length > 0) ? false :
                        item.icon.startsWith('fa_') ?
                            <FontAwesomeIcon icon={item.icon.substr(3)} fontSize='1.3rem' /> : // ?? this.accoSubItemStyle.fontSize} /> :
                            <img src={item.icon ?? `/images/polling/${(item.id ?? item.iid)}.png`} width={20} height={20} alt='' />
                }
                <span style={{ ...this.accoSubItemStyle, marginRight: '0.5rem' }}
                    className={'mdh_acco_subitem0 ' + style({
                        //color: Theme.col3(), backgroundColor: 'transparent', //Theme.col1('steelblue'),
                        '&:hover': {
                            //color: Theme.col2(),
                            //backgroundColor: Theme.col4(),
                        }
                    })}
                >
                    {item.text}
                </span>

                {item.counter > 0 &&
                    <span>
                        <Badge color='rgb(0 0 255 / 65%)' size={20} text={`${item.counter}`}
                            ifNoText='hide' style={{ paddingTop: '3px' }}
                        />
                    </span>
                }
                {ix === window.selectedSubIndex &&
                    <FontAwesomeIcon icon='circle-caret-left' fontSize='1.3rem'
                        style={{ position: 'absolute', left: '5px' }}
                    />
                }
            </div>
        );
    }

    renderAccoTitle = item => {
        let selected = item.index == this.state.selectedIndex;
        return (//isMobile ? <></> :
            <div className='mdh_acco_titleitem'
                style={{
                    display: 'flex', alignItems: 'center',
                    color: this.accoTitleStyle(selected).color,
                    backgroundColor: Theme.col1('steelblue'),
                }}>
                {!(item.icon?.length > 0) ? false :
                    item.icon.startsWith('fa_') ?
                        <FontAwesomeIcon icon={item.icon.substr(3)} fontSize={this.accoTitleStyle.fontSize}
                            onMouseEnter={isMobile || !this.state.collapsed ? undefined
                                : e => {
                                    if (this.state.hoveredItem?.id !== (item.id ?? item.iid))
                                        this.setState({ hoveredItem: item, hoveredX: e.clientX, hoveredY: e.clientY });
                                }}
                        />
                        :
                        <img src={item.icon} width={30} height={20} style={{ marginLeft: '5px' }} alt='' //id={'acco_it_icon_' + (item.id ?? item.iid)}
                            onMouseEnter={isMobile || !this.state.collapsed ? undefined
                                : e => {
                                    if (this.state.hoveredItem?.id !== (item.id ?? item.iid))
                                        this.setState({ hoveredItem: item, hoveredX: e.clientX, hoveredY: e.clientY });
                                }}
                        //onMouseLeave={e => this.setState({ hoveredItem: undefined })}
                        //onMouseOut={e => this.setState({ hoveredItem: '' })}
                        />
                }

                {this.state.collapsed ? //<></>
                    <ContextMenu items={item.items}//{this.state.items.find(x => x.id === (item.id ?? item.iid))?.items}
                        rtlEnabled target={`#acco_it_icon_${(item.id ?? item.iid)}`}
                        //itemRender={this.renderAccoSubItem}
                        itemRender={item => this.renderAccoSubItem(item, undefined, { backgroundColor: 'red', border: '1px solid red' })}
                        showEvent={{ name: 'mouseenter', delay: 0 }}
                        visible={this.state.hoveredItem?.id === (item.id ?? item.iid)}
                    />
                    :
                    <span style={this.accoTitleStyle(selected)}
                    >
                        {item.text}
                    </span>
                }
            </div>
        );
    }

    componentDidUpdate() {
        let titles = document.getElementsByClassName('dx-accordion-item-title');
        for (let x of titles)
            x.style.background = Theme.col1();
    }

    setCollapsed = (collapsed, whenDone) => {
        //SideMenu.collapsed = collapsed;
        this.setState({ collapsed, hoveredItem: undefined }, whenDone);
        this.props.onCollapseChanged?.(collapsed);
    }

    onCollapsedItemClick = e => {
        //e.itemElement.children[1].style.height = '0';
        //let subs = this.state.items.find(x => x.id === e.itemData.id)?.items;
    }

    render() {
        if (isMobile && this.state.collapsed)
            return (<></>);

        let ds = (this.state.items ?? []).map((item, index) => ({ index, ...item })); // this.state.collapsed ? this.state.items.map(i => ({ ...i, items: null })) : this.state.items;

        return (
            <>
                {(true || !isMobile) && //------------------------------------------------------------------------
                    <div className='ka-sideMenu' id='side_menu_container'
                        style={{
                            overflowX: 'hidden',
                            overflowY: window.mView && 'scroll',
                            position: 'relative',
                            height: this.props.height ?? `${MasterLayout.bodyHeight ?? (window.innerHeight - 60)}px`,
                            backgroundColor: Theme.col1(),
                            boxShadow: 'rgba(0, 0, 0, 0.16) 0px 10px 36px 0px, rgba(0, 0, 0, 0.06) 0px 0px 0px 1px',
                            zIndex: '500',
                        }}
                        onMouseEnter={!this.state.collapsed ? undefined : () => this.setState({ mouseInAcco: true })}
                        onMouseLeave={!this.state.collapsed ? undefined : () => this.setState({ mouseInAcco: false })}
                    >
                        <Accordion dataSource={ds} width={this.props.width ?? (isMobile ? '100%' : 250)}
                            animationDuration={1000}
                            //onItemTitleClick={e => console.log(e.itemIndex)}
                            key={`acco_${this.state.collapsed ? 1 : 0}`}

                            //className='ka_right_accordion'
                            className={'side_menu_acco ' + style({
                                color: Theme.col3('white'),
                                backgroundColor: Theme.col1('steelblue'),
                            })}

                            //height='100%'//VisualViewport.availHeight}//{`${MasterLayout.bodyHeight}px`}
                            height={MasterLayout.bodyHeight ?? (window.innerHeight - 60)}
                            selectedIndex={this.state.collapsed ? -1 : this.state.selectedIndex}
                            onSelectedIndexChange={i => {
                                if (!this.state.collapsed)
                                    this.setState({ selectedIndex: i }, () => {
                                        window.accoSelectedIndex = i;
                                        //console.log('accordion selected index changed to ', i); ///////////
                                    });
                            }}

                            focusStateEnabled activeStateEnabled hoverStateEnabled
                            collapsible={this.state.collapsed}
                            itemTitleRender={this.renderAccoTitle} //onItemRendered={i => console.log(i)}

                            itemRender={i => (
                                <List dataSource={i.items} itemRender={this.renderAccoSubItem}
                                    className={'mdh_acco_list ' + style({
                                        color: Theme.col0('white'),
                                        backgroundColor: Theme.col1('whitesmoke'),
                                        '& *': { padding: '0px' },
                                        height: (i.items?.length ?? 0) * 42 + 10 + 'px',
                                    })}
                                    scrollingEnabled scrollByThumb
                                    height={this.state.collapsed ? 0 : ((MasterLayout.bodyHeight ?? window.innerHeight)/**/
                                        - ds.length * 42) + 'px'}
                                    //height={(i.items?.length ?? 1) * 42 + 30}
                                    visible={!this.state.collapsed} //scrollByContent={true}
                                    noDataText=''
                                />
                            )}
                            onContentReady={this.onAccoContentReady}
                            onItemClick={this.state.collapsed ? this.onCollapsedItemClick : undefined}
                        //onItemClick={this.state.collapsed ? e => this.onCollapsedItemClick(e) : e => this.onClickSubMenu(e)}
                        />
                    </div>
                }
                {!isMobile && this.state.collapsed && this.state.hoveredItem?.items?.length > 0 &&
                    <div id='sidemenu_hovered1'
                        style={{
                            position: 'fixed',
                            top: (this.state.hoveredY - 20) + 'px',
                            right: '40px',
                            background: Theme.col1('white'),
                            zIndex: '1000',
                            width: '15rem',
                            border: '3px solid steelblue',
                            boxShadow: 'rgba(0, 0, 0, 0.25) 0px 54px 55px, rgba(0, 0, 0, 0.12) 0px -12px 30px, rgba(0, 0, 0, 0.12) 0px 4px 6px, rgba(0, 0, 0, 0.17) 0px 12px 13px, rgba(0, 0, 0, 0.09) 0px -3px 5px'
                            // '& *': {
                            //     padding: '0 !important'
                            // }
                        }}
                        onMouseLeave={() => {
                            if (!this.state.mouseInAcco)
                                this.setState({ hoveredItem: undefined });
                        }}
                    >
                        <List items={this.state.hoveredItem.items} rtlEnabled
                            itemRender={this.renderAccoSubItem}
                        />
                    </div>
                }
            </>
        );
    }
}

export default SideMenu;